// extracted by mini-css-extract-plugin
export default {"editBtnWrapper":"EditedPanel_editBtnWrapper__ZvZMk","buttons":"EditedPanel_buttons__7fAJ1","admin-btn":"EditedPanel_admin-btn__XIIL+"};